import { render, staticRenderFns } from "./dubbingScheme.vue?vue&type=template&id=7624a2aa&scoped=true"
import script from "./dubbingScheme.vue?vue&type=script&lang=js"
export * from "./dubbingScheme.vue?vue&type=script&lang=js"
import style0 from "./dubbingScheme.vue?vue&type=style&index=0&id=7624a2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7624a2aa",
  null
  
)

export default component.exports